'use strict'

function initializeLanguageFlyout() {
  $(document).ready(function () {
    // Toggle language flyout
        $('.js-open-lang-flyout, .js-close-lang-flyout').on('click', function (event) {
          event.preventDefault();
          event.stopPropagation();
          const flyout = $('#language-flyout')

          if ($('body').hasClass('no-overflow')) {
            $('body').removeClass('no-overflow')
          }

          if ($(flyout).hasClass('open')) {
            flyout.fadeOut(100, () => flyout.removeClass('open'))
            $('body').removeClass('no-overflow')
          } else {
            $('body').addClass('no-overflow')
            flyout.fadeIn(100, () => flyout.addClass('open'))
          }
        })
  })
}

export default initializeLanguageFlyout
